module.exports = __webpack_public_path__ + "static/media/login_header_logo.673498d2.png";